import React from 'react';
import NavBar from './NavBar';

export default function AuthLayout({ children }) {
  return (
    <>
      <NavBar />
      {children}
    </>
  );
}
